import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import type { ServerEvent } from '@irrigazione/shared';

/**
 * Aggancia lo stream SSE del server e invalida le query interessate.
 * Il traffico dei controller e' sporadico: il polling sarebbe quasi sempre a
 * vuoto, mentre qui la UI si aggiorna esattamente quando arriva un dato.
 */
export function useLive(): { connected: boolean } {
  const queryClient = useQueryClient();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const source = new EventSource('/api/stream');

    source.onopen = () => setConnected(true);
    source.onerror = () => setConnected(false); // EventSource riconnette da solo

    source.onmessage = (message) => {
      let event: ServerEvent;
      try {
        event = JSON.parse(message.data) as ServerEvent;
      } catch {
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['devices'] });
      if ('deviceId' in event) {
        queryClient.invalidateQueries({ queryKey: ['device', event.deviceId] });
        if (event.type === 'irrigation') {
          queryClient.invalidateQueries({ queryKey: ['history', event.deviceId] });
        }
      }
      if (event.type === 'gateway') {
        queryClient.invalidateQueries({ queryKey: ['gateways'] });
      }
    };

    return () => source.close();
  }, [queryClient]);

  return { connected };
}
